import { Navigate } from 'react-router-dom';
import ViewerStage from './ViewerStage';

/**
 * ShareGate (T13): /workspace/:companySlug/:screenSlug without an owner
 * session → viewer credential exchange + read-only live mirror. The stub form
 * from T2 is replaced by the real ViewerStage; signed-out visitors can join a
 * live share with the HOST's credentials. (Owner sign-in remains at /signin.)
 */
export default function ShareGate({ companySlug, screenSlug }) {
  return <ViewerStage companySlug={companySlug} screenSlug={screenSlug} />;
}
